/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */
import Message from '../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetDocumentDetailsMessage {
	documentId: string;
}

export default class GetDocumentDetailsMessage extends Message {
	public static readonly TYPE: string = '14';

	public static readonly READABLE_TYPE_NAME: string = 'getDocumentDetails';

	public static readonly DESCRIPTOR_NAME: string = 'GetDocumentDetailsMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			},
			environmentId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor(
		public readonly documentId: string
	) {
		super();
	}

	public get data(): IGetDocumentDetailsMessage {
		return {
			documentId: this.documentId
		};
	}

	public toJSON(): IGetDocumentDetailsMessage {
		return {
			documentId: this.documentId
		};
	}

	public static fromJSON( data: IGetDocumentDetailsMessage ): GetDocumentDetailsMessage {
		return new GetDocumentDetailsMessage(
			data.documentId
		);
	}
}
